module.exports = __webpack_public_path__ + "media/images/icon_down-8036e5493d76b3fb48437dd67cb2d0e7.svg";